import { Action } from '@ngrx/store';
import { Advertiser } from 'src/app/models/advertiser';



export enum AdvertiserActionsTypesNgrx {
  /*Get ALL ADVERTISER*/
  GET_ALL_ADVERTISER = '[Advertiser] Get All Advertisers',
  GET_ALL_ADVERTISER_SUCCESS = '[Advertiser] Get All Advertisers Success',
  GET_ALL_ADVERTISER_ERROR = '[Advertiser] Get All Advertisers Error',
  /*Get SEARCH ADVERTISER*/
  SEARCH_ADVERTISER = '[Advertiser] Get Search Advertisers',
  SEARCH_ADVERTISER_SUCCESS = '[Advertiser] Get Search Advertisers Success',
  SEARCH_ADVERTISER_ERROR = '[Advertiser] Get Search Advertisers Error',

  /*Get SEARCH ADVERTISER*/
  GET_ADVERTISER_BY_NAME = '[Advertiser] Get Advertiser by name',
  GET_ADVERTISER_BY_NAME_SUCCESS = '[Advertiser] Get Advertiser by name Success',
  GET_ADVERTISER_BY_NAME_ERROR = '[Advertiser] Get Advertiser by name Error',

  /*Get NEW ADVERTISER*/
  NEW_ADVERTISER = '[Advertiser] Get NEW Advertisers',
  NEW_ADVERTISER_SUCCESS = '[Advertiser] Get NEW Advertisers Success',
  NEW_ADVERTISER_ERROR = '[Advertiser] Get NEW Advertisers Error',

  /*Get SAVE ADVERTISER*/
  SAVE_ADVERTISER = '[Advertiser] Get SAVE Advertisers',
  SAVE_ADVERTISER_SUCCESS = '[Advertiser] Get SAVE Advertisers Success',
  SAVE_ADVERTISER_ERROR = '[Advertiser] Get SAVE Advertisers Error',

  /*Get EDIT ADVERTISER*/
  EDIT_ADVERTISER = '[Advertiser] Get EDIT Advertisers',
  EDIT_ADVERTISER_SUCCESS = '[Advertiser] Get EDIT Advertisers Success',
  EDIT_ADVERTISER_ERROR = '[Advertiser] Get EDIT Advertisers Error',

  /*Get UPDATE ADVERTISER*/
  UPDATE_ADVERTISER = '[Advertiser] Get UPDATE Advertisers',
  UPDATE_ADVERTISER_SUCCESS = '[Advertiser] Get UPDATE Advertisers Success',
  UPDATE_ADVERTISER_ERROR = '[Advertiser] Get UPDATE Advertisers Error',

  /*Get DELETE ADVERTISER*/
  DELETE_ADVERTISER = '[Advertiser] Get DELETE Advertisers',
  DELETE_ADVERTISER_SUCCESS = '[Advertiser] Get DELETE Advertisers Success',
  DELETE_ADVERTISER_ERROR = '[Advertiser] Get DELETE Advertisers Error',

}

/*Get ALL ADVERTISER ACTIONS*/
export class GetAllAdvertisersAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.GET_ALL_ADVERTISER;
  constructor(public payload: any) { }
}

export class GetAllAdvertisersActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.GET_ALL_ADVERTISER_SUCCESS;
  constructor(public payload: Advertiser[]) { }
}

export class GetAllAdvertisersActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.GET_ALL_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}

/*Get ADVERTISER BY NAME ACTIONS*/
export class GetAdvertiserByNameAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME;
  constructor(public payload: any) { }
}

export class GetAdvertiserByNameActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME_SUCCESS;
  constructor(public payload: Advertiser) { }
}

export class GetAdvertiserByNameActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.GET_ADVERTISER_BY_NAME_ERROR;
  constructor(public payload: string) { }
}

/*Get SEARCH ADVERTISER ACTIONS*/
export class SearchAdvertisersAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.SEARCH_ADVERTISER;
  constructor(public payload: string) { }
}

export class SearchAdvertisersActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.SEARCH_ADVERTISER_SUCCESS;
  constructor(public payload: Advertiser[]) { }
}

export class SearchAdvertisersActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.SEARCH_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}

/*Get DELETE ADVERTISER ACTIONS*/
export class DeleteAdvertiserAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.DELETE_ADVERTISER;
  constructor(public payload: Advertiser) { }
}

export class DeleteAdvertiserActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.DELETE_ADVERTISER_SUCCESS;
  constructor(public payload: Advertiser) { }
}

export class DeleteAdvertiserActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.DELETE_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}

/*Get NEW ADVERTISER ACTIONS*/
export class NewAdvertiserAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.NEW_ADVERTISER;
  constructor(public payload: any) { }
}

export class NewAdvertiserActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.NEW_ADVERTISER_SUCCESS;
  constructor(public payload: any) { }
}

export class NewAdvertiserActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.NEW_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}

/*Get SAVE ADVERTISER ACTIONS*/
export class SaveAdvertiserAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.SAVE_ADVERTISER;
  constructor(public payload: Advertiser) { }
}

export class SaveAdvertiserActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.SAVE_ADVERTISER_SUCCESS;
  constructor(public payload: Advertiser) { }
}

export class SaveAdvertiserActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.SAVE_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}

/*Get EDIT ADVERTISER ACTIONS*/
export class EditAdvertiserAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.EDIT_ADVERTISER;
  constructor(public payload: string) { }
}

export class EditAdvertiserActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.EDIT_ADVERTISER_SUCCESS;
  constructor(public payload: Advertiser) { }
}

export class EditAdvertiserActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.EDIT_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}


/*Get UPDATE ADVERTISER ACTIONS*/
export class UpdateAdvertiserAction implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.UPDATE_ADVERTISER;
  constructor(public payload: Advertiser) { }
}

export class UpdateAdvertiserActionSuccess implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.UPDATE_ADVERTISER_SUCCESS;
  constructor(public payload: Advertiser) { }
}

export class UpdateAdvertiserActionError implements Action {
  type: AdvertiserActionsTypesNgrx = AdvertiserActionsTypesNgrx.UPDATE_ADVERTISER_ERROR;
  constructor(public payload: string) { }
}


export type AdvertiserActions =
  GetAllAdvertisersAction | GetAllAdvertisersActionSuccess | GetAllAdvertisersActionError |

  SearchAdvertisersAction | SearchAdvertisersActionSuccess | SearchAdvertisersActionError |

  DeleteAdvertiserAction | DeleteAdvertiserActionSuccess | DeleteAdvertiserActionError |
  NewAdvertiserAction | NewAdvertiserActionSuccess | NewAdvertiserActionError |
  SaveAdvertiserAction | SaveAdvertiserActionSuccess | SaveAdvertiserActionError |
  EditAdvertiserAction | EditAdvertiserActionSuccess | EditAdvertiserActionError |
  UpdateAdvertiserAction | UpdateAdvertiserActionSuccess | UpdateAdvertiserActionError;
